export default __webpack_public_path__ + "static/media/bnbCircle.797868eb.svg";